import VSelectCardTicketList from './index.vue';

export default {
  install: (Vue) => Vue.component('VSelectCardTicketList', VSelectCardTicketList),
};
